/**
 * WM Product Card Renderer
 * Replicates the HTML structure of snippets/product-card-custom-v2.liquid
 */

const WMProductCard = {
  formatMoney(amount, currencyCode = "USD") {
    if (!amount) return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
    }).format(amount);
  },

  formatDate(dateString) {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  },

  renderProductCard(product, sectionId) {
    const getNumericId = (gid) => (gid ? gid.split('/').pop() : '');
    const variants = product.variants?.edges?.map(e => e.node) || [];
    const variant = variants.find(v => v.availableForSale) || variants[0];
    if (!variant) return "";

    const productId = getNumericId(product.id);
    const variantId = getNumericId(variant.id);
    const productFormId = `product-form-${sectionId}-${productId}`;
    const productFormClass = `main-product-form product-form-custom-v2 product-form-${sectionId}`;

    const variantImage = product.featuredImage ? product.featuredImage.url : "";
    const variantMediaSmall = `${variantImage}&width=100`;

    const isAvailable = variant.availableForSale;
    const price = this.formatMoney(
      variant.price.amount,
      variant.price.currencyCode,
    );
    const compareAtPrice = variant.compareAtPrice
      ? this.formatMoney(
          variant.compareAtPrice.amount,
          variant.compareAtPrice.currencyCode,
        )
      : null;

    return `
            <div class="swiper-slide">
                <form
                    action="/cart/add"
                    method="post"
                    id="${productFormId}"
                    class="${productFormClass}"
                    accept-charset="UTF-8"
                    enctype="multipart/form-data"
                    novalidate="novalidate"
                    data-type="add-to-cart-form"
                    data-product-id="${productId}"
                    data-product-handle="${product.handle}"
                >
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${variantId}" data-selected-variant ${!isAvailable ? "disabled" : ""}>
                    <input type="hidden" name="quantity" value="1">

                    <article class="media-card this-is-custom">
                        <div class="media-card-image">
                            ${
                              product.featuredImage
                                ? `
                                <img
                                    src="${product.featuredImage.url}"
                                    loading="lazy"
                                    widths="373, 550, 746"
                                    sizes="(min-width: 1440px) 373px, (min-width: 992px) 25vw, 100vw"
                                    width="373"
                                    height="433"
                                    alt="${product.featuredImage.altText || product.title}"
                                >
                            `
                                : ""
                            }
                        </div>

                        <div class="media-card-body">
                            <div class="media-card-date">
                                <img src="https://cdn.shopify.com/s/files/1/0951/7334/5569/files/clock.svg?v=1783336225" width="19" height="19" alt="">
                                <span>${product.publishedAt ? this.formatDate(product.publishedAt) : ""}</span>
                            </div>

                            <div class="media-card-row">
                                <div class="media-card-info">
                                    <h3 class="media-card-title">
                                        <a href="/products/${product.handle}">
                                            ${product.title}
                                        </a>
                                    </h3>

                                    <div class="media-card-pricing">
                                        <span class="price-sale">${price}</span>
                                        ${compareAtPrice ? `<span class="price-original">${compareAtPrice}</span>` : ""}
                                    </div>

                                    <button
                                        type="button"
                                        name="add"
                                        class="cart-btn cart-btn--mobile js-custom-add-to-cart"
                                        form="${productFormId}"
                                        ${!isAvailable ? "disabled" : ""}
                                    >
                                        ${isAvailable ? "Add to cart" : "Sold out"}
                                    </button>
                                </div>

                                <div class="media-card-action">
                                    <add-to-cart-component
                                        ref="addToCartButtonContainer"
                                        data-product-variant-media="${variantMediaSmall}"
                                        data-add-to-cart-animation="true"
                                    >
                                        <button
                                            type="button"
                                            name="add"
                                            ref="addToCartButton"
                                            class="button add-to-cart-button cart-btn cart-btn--icon js-custom-add-to-cart"
                                            form="${productFormId}"
                                            data-testid="standalone-add-to-cart"
                                            aria-label="${isAvailable ? "Add " + product.title + " to cart" : "Sold out"}"
                                            ${!isAvailable ? "disabled" : ""}
                                        >
                                            <span class="add-to-cart-text">
                                                <img src="https://cdn.shopify.com/s/files/1/0951/7334/5569/files/cart-icon.svg?v=1783336133" width="30" height="30" alt="">
                                                <span class="add-to-cart-text__content visually-hidden">Add to cart</span>
                                            </span>
                                            <span class="add-to-cart__added">
                                                <span class="svg-wrapper add-to-cart__added-icon">
                                                    <svg aria-hidden="true" class="checkmark-burst" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <g class="check">
                                                        <circle class="ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                                                        <path class="tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                      </g>
                                                      <g class="burst">
                                                        <g style="--index: 0;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                                                        <g style="--index: 1;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                                                        <g style="--index: 2;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                                                        <g style="--index: 3;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                                                        <g style="--index: 4;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                                                        <g style="--index: 5;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                                                        <g style="--index: 6;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                                                        <g style="--index: 7;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                                                      </g>
                                                    </svg>
                                                </span>
                                            </span>
                                        </button>
                                    </add-to-cart-component>
                                </div>
                            </div>
                        </div>
                    </article>
                    <input type="hidden" name="product-id" value="${productId}">
                    <input type="hidden" name="section-id" value="${sectionId}">
                </form>
            </div>
    `;
  },
};

window.WMProductCard = WMProductCard;
